const parseErrorMessagesList = (message) => {
  // TODO: Localize error messages
  // function toLowerCase(string){
  //   return string.charAt(0).toLowerCase() + string.slice(1);
  // }
  function stripThis(string) {
    return string.replace("This", "");
  }
  const flattenArray = (arr) => [].concat(...arr);

  let typeOfError = typeof message;
  //console.log("type of error", typeOfError);

  function processErrorObject(message) {
    let messageKeys = Object.keys(message);
    //console.log("in process error object", messageKeys);
    let errorMessages = messageKeys.map((key) => {
      if (key.includes("OKTA") || key.includes("recaptcha_response")) {
        let messageValue = message[key].join(", ");
        //return [messageValue];
        return Array.of(messageValue);
      }
      if (key.includes("vtoken")) {
        return message[key];
      }

      let allErrors = message[key].map(function (item) {
        if (item.includes("required field")) {
          switch (key) {
            case "username":
              return ["Username", stripThis(item)];
            case "email":
              return ["Email", stripThis(item)];
            case "fname":
              return ["First name", stripThis(item)];
            case "lname":
              return ["Last name", stripThis(item)];
            case "addr1":
              return ["Address", stripThis(item)];
            case "phone1":
              return ["Phone", stripThis(item)];

            default:
              return [key, stripThis(item)];
          }
        }

        return [item, ""];
      });
      return flattenArray(allErrors);
    });
    return errorMessages;
  }

  switch (typeOfError) {
    case "string":
      return message;
    case "object":
      return processErrorObject(message);

    default:
      console.log("no such case");
  }
};
export default parseErrorMessagesList;
